<template>
  <PopUpModalStrip ref="popup">
    <!-- ------------ -->
    <!--  container   -->
    <!-- ------------ -->
    <div class="container-fluid">
      <div class="col p-3">
        <!-- -------------- -->
        <!--  main column   -->
        <!-- -------------- -->
        <div
          class="row bb-sub-hdg mt-1 mb-3 justify-content-center text-center"
        >
          {{ title }} [{{ row.name }}]
        </div>
        <!-- ------- -->
        <!--  row 1  -->
        <!-- ------- -->
        <div class="row">
          <p class="bb-sub-sub-hdg mt-1 mb-3 text-center">SELECTED</p>
          <div class="bb-slot-listing">
            <!-- ------------------- -->
            <!--    current slots    -->
            <!-- ------------------- -->
            <div
              v-for="(cur_slot, index_cur) in cur_slots"
              :key="index_cur"
            >
              <div class="col-lg px-1">
                <img
                  :id="'cur_img_' + index_cur"
                  :src="cur_slot.image"
                  class="img-fluid rounded bb-img-norm-border bb-hover"
                  @click="selectionMarkerClick('cur_img_' + index_cur)"
                  alt="current slot image"
                />
                <div
                  class="row bb-sub-sub-sub-hdg mt-3 mb-2 justify-content-center text-center"
                  :id="'cur_lbl_' + index_cur"
                >
                  {{ cur_slot.label }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ------- -->
        <!--  row 2  -->
        <!-- ------- -->
        <div class="row">
          <p class="bb-sub-sub-hdg mt-2 mb-2 text-center">AVAILABLE</p>
          <div class="bb-slot-listing">
            <!-- ------------------ -->
            <!--   available slots  -->
            <!-- ------------------ -->
            <div
              v-for="(avail_slot, index_avail) in avail_slots"
              :key="index_avail"
            >
              <div class="col-lg m-2">
                <img
                  :id="'avail_img_' + index_avail"
                  :src="avail_slot.image"
                  class="img-fluid rounded bb-img-norm-border bb-hover"
                  @click="availableMarkerClick('avail_img_' + index_avail)"
                  alt="available slot image"
                />
                <div
                  class="row bb-sub-sub-sub-hdg mt-3 mb-2 justify-content-center text-center"
                  :id="'avail_lbl_' + index_avail"
                >
                  {{ avail_slot.label }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- ------- -->
        <!--  row 3  -->
        <!-- ------- -->
        <div class="row mt-2 mb-3">
          <!-- ------------ -->
          <!--    buttons   -->
          <!-- ------------ -->
          <div
            class="btn-group special"
            role="group"
          >
            <!-- ------------ -->
            <!--    cancel    -->
            <!-- ------------ -->
            <button
              type="submit"
              @click="_cancel"
              class="btn btn-lg btn-warning"
            >
              Cancel
            </button>
            <!-- ------------ -->
            <!--      OK      -->
            <!-- ------------ -->
            <button
              type="submit"
              @click="_confirm"
              :disabled="!isChanged"
              class="btn btn-lg btn-primary"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  </PopUpModalStrip>
</template>
<script>
//=====================================================================
// imports
//---------
import PopUpModalStrip from './PopUpModalStrip.vue'
import getMarker from '../helpers/getMarker'
import sleep from '../helpers/sleep'

export default {
  name: 'MarkersDialog',
  components: {
    PopUpModalStrip,
  },
  //=====================================================================
  // data
  //------
  data: () => ({
    cur_slots: undefined,
    avail_slots: undefined,
    original_marker_names: [],
    title: undefined,
    row: undefined,
    selected_cur_slot_id: null,
    okButton: 'OK',
    cancelButton: 'Cancel',
    resolvePromise: undefined,
    rejectPromise: undefined,
    saveAvailableMarkerId: '',
  }),
  //=====================================================================
  // computed
  //----------
  computed: {
    non_empty_markers() {
      return (this.cur_slots ?? []).filter((a) => a.name != 'empty')
    },
    isChanged() {
      return (
        JSON.stringify(this.current_marker_names) !==
        JSON.stringify(this.original_marker_names)
      )
    },
    current_marker_names() {
      return this.non_empty_markers.map((a) => a.name)
    },
  },
  //=====================================================================
  // methods
  //---------
  methods: {
    //=====================================================================
    // show
    //------
    async show(opts = {}) {
      this.cur_slots = opts.cur_slots
      this.avail_slots = opts.avail_slots
      this.original_marker_names = this.cur_slots
        .filter((a) => a.name != 'empty')
        .map((a) => a.name)
      this.title = opts.title
      this.row = opts.row
      // this.okButton = opts.okButton;
      if (opts.cancelButton) {
        this.cancelButton = opts.cancelButton
      }
      //
      let call = this.$refs.popup.open()
      await call.then(() => {
        this.changeAvailSlots()
        this.changeCurSlots()
      })
      //
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    //=====================================================================
    // confirm
    //---------
    _confirm() {
      if (!this.isChanged) {
        return
      }

      sleep(100).then(() => {
        this.$refs.popup.close()
        let just_names = this.non_empty_markers.map((a) => a.name)
        // for (var key of Object.keys(just_names)) {
        //   console.log(key + " -> " + just_names[key]);
        // }
        this.resolvePromise(just_names)
      })
    },
    //=====================================================================
    // cancel
    //--------
    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise()
    },
    //================================================
    // available marker click
    //------------------------
    availableMarkerClick(id) {
      // console.log("availableMarkerClick...");
      //---------------------------------
      // find first empty selection slot
      //---------------------------------
      let idx_before = this.cur_slots.findIndex((a) => a.name == 'empty')
      //------------------------------------
      // copy avail to empty selection slot
      //------------------------------------
      this.cur_slots[idx_before] = this.avail_slots[id.slice(-1)]
      //------------------------
      // change avail/cur slots
      //------------------------
      this.changeAvailSlots()
      this.changeCurSlots()
      //--------------------------------------
      // check for remaining empty selections
      //--------------------------------------
      let idx_after = this.cur_slots.findIndex((a) => a.name == 'empty')
      //--------------------------------------------
      // selections full - disable remaining avails
      //--------------------------------------------
      if (idx_after == -1) {
        this.disableRemainingAvails()
      }
    },
    //================================================
    // selection marker click (clear)
    //------------------------
    selectionMarkerClick(id) {
      // console.log("selectionMarkerClick...");
      //---------------------------
      // get id number = array idx
      //---------------------------
      let id_idx = id.slice(-1)
      //------------------
      // get empty marker
      //------------------
      let empty_marker = getMarker('empty')
      //---------------------------
      // set clicked slot as empty
      //---------------------------
      this.cur_slots[id_idx] = empty_marker
      //---------------------
      // get new non-empties
      //---------------------
      let non_empty_markers = this.cur_slots.filter((a) => a.name != 'empty')
      //-----------------
      // clear cur slots
      //-----------------
      for (let i = 0; i < this.cur_slots.length; i++) {
        this.cur_slots[i] = empty_marker
      }
      //------------------------------------
      // fill cur slots with actual markers
      //------------------------------------
      for (let j = 0; j < non_empty_markers.length; j++) {
        this.cur_slots[j] = non_empty_markers[j]
      }
      //------------------------
      // change avail/cur slots
      //------------------------
      this.changeAvailSlots()
      this.changeCurSlots()
    },
    //================================================
    // disable remaining avails
    //-------------------------
    disableRemainingAvails() {
      // console.log("-------------------");
      // console.log("disableRemainingAvails");
      //------------------
      // loop avail slots
      //------------------
      for (let i = 0; i < this.avail_slots.length; i++) {
        //---------
        // set ids
        //---------
        let img_id = 'avail_img_' + i
        let lbl_id = 'avail_lbl_' + i
        //-----------------------------
        // where still avail - disable
        //-----------------------------
        var el = document.getElementById(img_id)
        if (el.style.pointerEvents == 'auto') {
          this.disableImage(img_id)
          this.disableText(lbl_id)
        }
      }
    },
    //================================================
    // enable image
    //--------------
    enableImage(id) {
      var el = document.getElementById(id)
      el.style.opacity = '1.0'
      el.style.pointerEvents = 'auto'
    },
    //================================================
    // enable text
    //-------------
    enableText(id) {
      var el = document.getElementById(id)
      el.style.color = '#25bfda'
    },
    //================================================
    // disable image
    //---------------
    disableImage(id) {
      var el = document.getElementById(id)
      el.style.opacity = '0.2'
      el.style.pointerEvents = 'none'
    },
    //================================================
    // disable text
    //--------------
    disableText(id) {
      var el = document.getElementById(id)
      el.style.color = '#737373'
    },
    //================================================
    // change available slots
    //------------------------
    changeAvailSlots() {
      // console.log("-------------------");
      // console.log("changeAvailSlots");
      //-----------------------
      // loop thru avail slots
      //-----------------------
      for (let i = 0; i < this.avail_slots.length; i++) {
        //---------
        // set ids
        //---------
        let img_id = 'avail_img_' + i
        let lbl_id = 'avail_lbl_' + i
        //------------------
        // check selections
        //------------------
        let avail_img_selected = this.cur_slots.some(
          (a) => a.name == this.avail_slots[i].name,
        )
        //--------------------------
        // selected - disable avail
        //--------------------------
        if (avail_img_selected) {
          this.disableImage(img_id)
          this.disableText(lbl_id)
          //-----------------------------
          // not selected - enable avail
          //-----------------------------
        } else {
          this.enableImage(img_id)
          this.enableText(lbl_id)
        }
      }
    },
    //================================================
    // change current slots
    //----------------------
    changeCurSlots() {
      // console.log("-------------------");
      // console.log("changeCurSlots");
      //---------------------
      // loop thru cur slots
      //---------------------
      for (let i = 0; i < this.cur_slots.length; i++) {
        //---------
        // set ids
        //---------
        let img_id = 'cur_img_' + i
        let lbl_id = 'cur_lbl_' + i
        //--------------------
        // is empty - disable
        //--------------------
        if (this.cur_slots[i].name == 'empty') {
          this.disableImage(img_id)
          this.disableText(lbl_id)
          //-----------------------
          // is not empty - enable
          //-----------------------
        } else {
          this.enableImage(img_id)
          this.enableText(lbl_id)
        }
      }
    },
  },
}
</script>
